import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Silence the CRA dev error overlay for *handled* axios errors. Real bugs
// (TypeError, ReferenceError, …) still surface — we only ignore promise
// rejections from axios where the response is a 401/403/4xx that the app
// is allowed to recover from. Anything else re-throws.
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const isAxios = reason && reason.isAxiosError;
  if (isAxios) {
    // Cookie-expired / session-gone / generic 4xx — already handled by
    // the global interceptor or a per-page .catch(). Don't crash the UI.
    event.preventDefault();
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[swallowed axios rejection]", reason.message, reason.config?.url);
    }
  }
});

// Register the PWA service worker (production only).
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
